/**
 * availabilityApi.js
 *
 * Thin fetch wrapper around the Cloud Function's POST /registerAvailability
 * route (added to index.js alongside /registerVisitor, /registerPrenatal,
 * and /registerCallback).
 *
 * API_BASE_URL assumes the Firebase Hosting rewrite convention used by the
 * rest of this app — i.e. requests to /api/** are rewritten to the `api`
 * Cloud Function, so a same-origin call to "/api/registerAvailability" just
 * works in production. If this project instead has a shared axios/fetch
 * client that the other forms (Contact Us, Prenatal, Callback) already use,
 * swap this file out for that and keep the same submitAvailabilityRequest
 * export so Availability.js doesn't need to change.
 */

const API_BASE_URL =
  "https://us-central1-website-a1336.cloudfunctions.net/api";

export const submitAvailabilityRequest = async ({
  name,
  mobile,
  countryCode = "+91",
  email,
  date,
  time,
  source,
}) => {
  const response = await fetch(`${API_BASE_URL}/registerAvailability`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, mobile, countryCode, email, date, time, source }),
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    // Non-JSON response (e.g. a gateway error page) — fall through to the
    // generic error below.
  }

  if (!response.ok) {
    const message =
      payload?.error?.[0]?.msg ||
      payload?.errorMessage ||
      "We couldn't process your request. Please try again.";
    throw new Error(message);
  }

  return payload;
};
